import axios from 'axios';
import { toolUtils } from '../../../../utils/toolUtils.js'
import { Tag, Typography, Popconfirm, message, Spin, Modal, Button, Row, Col, Card } from 'antd';
import {
    CloseOutlined,
    CheckCircleOutlined,
    DragOutlined
} from '@ant-design/icons';

export default {
    getConference: async function (props, setFuncMap) {
        try {
            const res = await this.getConferenceByUidAction(props.conferenceUid)
            props.setContentHeader(res.data.name)
            setFuncMap.setIsPageLoading(false)
        } catch (error) {
        }
    },
    getConferenceByUidAction: (conferenceUid) => {
        return axios({
            method: 'GET',
            url: `/conference/${conferenceUid}`,
            headers: {
                "role": "topUser"
            }
        })
    },
    getRegistrationFees: async function (props, setFuncMap) {
        try {
            setFuncMap.setIsContentLoading(true)
            const res = await this.getRegistrationFeesAction(props.conferenceUid)
            let result = {}
            res.data.forEach(item => {
                result[item.lang] = item
            })
            setFuncMap.setRegistrationFeeMap(result)
            setFuncMap.setIsContentLoading(false)
        } catch (error) {
        }
    },
    getRegistrationFeesAction: (conferenceUid) => {
        return axios({
            method: 'GET',
            url: `/conference/${conferenceUid}/registration-fee`,
            headers: {
                "role": "topUser"
            }
        })
    },
    updateRegistrationFee: async function (payload, props, setFuncMap) {
        try {
            setFuncMap.setIsContentLoading(true)
            const res = await this.updateRegistrationFeeAction(payload, props.conferenceUid)
            setFuncMap.setIsContentLoading(false)
        } catch (error) {
        }
    },
    updateRegistrationFeeAction: (payload, conferenceUid) => {
        return axios({
            method: 'POST',
            url: `/conference/${conferenceUid}/registration-fee`,
            headers: {
                "role": "topUser"
            },
            data: payload
        })
    },
    getRegistrationFee: async function (props, setFuncMap) {
        try {
            setFuncMap.setIsContentLoading(true)
            const res = await this.getRegistrationFeeByIdAction(props.conferenceUid)
            let result = {}
            res.data.forEach(item => {
                result[item.lang] = item
            })
            setFuncMap.setRegistrationFeeMap(result)
            setFuncMap.setIsContentLoading(false)
        } catch (error) {
        }
    },
    getRegistrationFeeByIdAction: (conferenceUid) => {
        return axios({
            method: 'GET',
            url: `/conference/${conferenceUid}/registration-fee`,
            headers: {
                "role": "topUser"
            }
        })
    },
};
